module.exports = __webpack_public_path__ + "static/media/mrpoopyIcon.483545e8.png";